"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamakerApplication = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ConfiguratorContext_1 = require("./ConfiguratorContext");
const DynamakerApplication = ({ appId, production, args }) => {
    const configurator = (0, ConfiguratorContext_1.useConfiguratorContext)();
    const url = (0, react_1.useMemo)(() => {
        const appUrl = new URL(`https://deployed.dynamaker.com/applications/${production ? '' : 'test/'}${appId}/`);
        if (args)
            Object.entries(args).forEach(([key, value]) => appUrl.searchParams.append(key, value));
        return appUrl.href;
    }, [appId, production, args]);
    const [ref, setRef] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => ref && configurator.setIframeRef(ref), [ref]);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(App, { ref: setRef, src: url, disablePointerEvents: !!configurator.incomingItem }),
        react_1.default.createElement(DropTarget, { hidden: !configurator.incomingItem, onDragOver: e => {
                if (!ref)
                    return;
                e.preventDefault();
                e.stopPropagation();
                const { x, y } = ref.getBoundingClientRect();
                configurator.handleDragOver(e.clientX - x, e.clientY - y);
            }, onDrop: e => {
                if (!ref)
                    return;
                e.stopPropagation();
                const { x, y } = ref.getBoundingClientRect();
                configurator.handleDrop(e.clientX - x, e.clientY - y);
            }, onTouchEnd: e => {
                var _a, _b;
                if (!ref)
                    return;
                e.stopPropagation();
                const tX = ((_a = e.touches[0]) !== null && _a !== void 0 ? _a : e.changedTouches[0]).pageX;
                const tY = ((_b = e.touches[0]) !== null && _b !== void 0 ? _b : e.changedTouches[0]).pageY;
                const { x, y } = ref.getBoundingClientRect();
                configurator.handleDrop(tX - x, tY - y);
            }, onMouseOver: _ => configurator.setIncomingItem(undefined), onPointerDown: _ => configurator.setIncomingItem(undefined) })));
};
exports.DynamakerApplication = DynamakerApplication;
const Container = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const App = styled_components_1.default.iframe `
  width: 100%;
  height: 100%;
  flex: 1;
  border: 0;
  pointer-events: ${(p) => p.disablePointerEvents ? 'none' : 'auto'};
`;
const DropTarget = styled_components_1.default.div `
  background: #000;
  opacity: 0.001;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 1001;
`;
